import { Card as AntdCard } from 'antd'
import AntdItem from 'antd/lib/list/Item'
import AntdText from 'antd/lib/typography/Text'
import styled from 'styled-components'

export const Card = styled(AntdCard)`
  margin: 3rem;
`

export const ListItem = styled(AntdItem)`
  align-items: center;
  cursor: pointer;
  display: flex;
  &:nth-child(odd) {
    background-color: #f0f0f0;
  }

  &:nth-child(even) {
    background-color: #ffffff;
  }

  .sequence {
    flex: 0 0 50px;
    text-align: center;
  }

  .dates {
    flex: 0 0 150px;
    display: flex;
    justify-content: space-between;
    gap: 8px;
  }

  .description {
    flex: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`

export const Text = styled(AntdText)`
  flex: 0 0 100px;
  text-align: center;
`
